:host {
  display: block;
  height: 3rem;
  width: 3rem;
}

svg {
  width: 100%;
  height: 100%;
}
